// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Zlhf{position:relative}.i3vwC{color:var(--anchore-color-gray-500);font-size:1rem;pointer-events:none;position:absolute;right:.75rem;top:.75rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `_Zlhf`,
	"disabledIcon": `i3vwC`
};
module.exports = ___CSS_LOADER_EXPORT___;
